import { api } from '@/shared/api/httpClient'
import type { ActionResult, AdoptBody, Device, Discovery, Driver } from '@/features/devices/types'

export const devicesApi = {
  list: () => api.get<Device[]>('/devices/'),
  get: (id: number) => api.get<Device>(`/devices/${id}/`),
  move: (id: number, room: number | null) => api.patch<Device>(`/devices/${id}/`, { room }),
  action: (id: number, action: string, params: Record<string, unknown> = {}) =>
    api.post<ActionResult>(`/devices/${id}/actions/${action}/`, { params }),
  reconnect: (id: number) => api.post<Device>(`/devices/${id}/reconnect/`),
  remove: (id: number) => api.delete<void>(`/devices/${id}/`),

  drivers: () => api.get<Driver[]>('/drivers/'),
  saveCredentials: (credentialKey: string, values: Record<string, string>) =>
    api.post<void>(`/drivers/${credentialKey}/credentials/`, { values }),
  discover: () => api.post<Discovery>('/discovery/'),
  adopt: (body: AdoptBody) => api.post<{ devices: Device[] }>('/devices/adopt/', body),

  // Só a contagem para o resumo da tela inicial; a feature mcp é dona do resto.
  agentCount: () => api.get<unknown[]>('/mcp/connections/').then((list) => list.length),
}
